import React from "react";
import { useSelector } from "react-redux";
import { Placeholder } from "semantic-ui-react";

const LoadingCard = ({ commonLoading, className, children }) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  return (
    loadingStatus ||
    (commonLoading && (
      <Placeholder
        inverted={isDarkMode}
        className={`${className} !mt-[12px] h-[7px] rounded-full`}
      >
        {children}
      </Placeholder>
    ))
  );
};

export default LoadingCard;
